// extracted by mini-css-extract-plugin
export var globeContainer = "index-module--globeContainer---opEi";
export var marker = "index-module--marker--MC4l4";
export var user = "index-module--user--CTdSL";